import React, {useEffect, useRef, useState} from "react";
import {observer} from "mobx-react";
import {fabric} from "fabric";
import {createAxiosEntrepriseInstance} from "../../../axiosEntreprise";
import {useParams} from "react-router-dom";
import {useStores} from "../../../stores/Context";
import SidebarWidgets from "../../SidebarWidgets/SidebarWidgets";
import "./TableauBlanc.scss";
import Canva from "./Canva";
import CanvaListe from "./CanvaListe";


const TableauBlanc = observer(() => {
    const {uiStore, TableauBlancStore, widgetStore} = useStores();

    if (TableauBlancStore.isLoading) {
        return (
            <div className={"loading"}>
                <p>Chargement...</p>
            </div>
        );
    } else if (TableauBlancStore.idCanvas !== null) {
        return (
            <Canva/>
        );

    } else {
        return (
            <CanvaListe/>
        );
    }

    return "TableauBlanc";
});

export default TableauBlanc;
